
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lms",
      function () {
        return require("private-next-pages/lms.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lms"])
      });
    }
  